'use client';
import React from 'react';

import Hooks from '@benzinga/hooks';
import { SessionContext } from '@benzinga/session-context';
import { SubscriptionsManager, SubscriptionsManagerEvent } from '@benzinga/subscription-manager';
import { BenzingaContext } from '../context';
import { useUserSubscriptions } from './useUserSubscriptions';

/**
 * Hook to check if a user has an active subscription or not
 */
export const useUserHasCanceledSubscription = (productSlug?: string): boolean | undefined => {
  const session = React.useContext(SessionContext);
  const subscriptionManager = session.getManager(SubscriptionsManager);

  const benzingaContext = React.useContext(BenzingaContext);
  productSlug = productSlug ?? benzingaContext?.slug.product;

  const user = useUserSubscriptions();
  const [hasActiveSubscription, setHasActiveSubscription] = React.useState(
    user === undefined ? undefined : !!subscriptionManager.getCanceledSubscriptionStored(productSlug),
  );

  Hooks.useSubscriber(subscriptionManager, (event: SubscriptionsManagerEvent) => {
    switch (event.type) {
      case 'subscription:user_subscriptions_changed':
        setHasActiveSubscription(!!subscriptionManager.getCanceledSubscriptionStored(productSlug));
        break;
    }
  });

  return hasActiveSubscription;
};
